import React from 'react';
import PropTypes from 'prop-types';

import akbIcon from '../../assets/images/universal-board-logo.svg';
import defaultBoardImg from '../../assets/images/board-default-icon.svg';
import personalBoardImg from '../../assets/images/board-person-icon.svg';

const DashboardInfo = ({ dashboard }) => {
  const isAkb = dashboard.akbBoardId && dashboard.akbBoardId !== 'false';
  
  const renderDashboardImage = () => {
    if (dashboard.organization && !dashboard.organization.logo) {
      return (
        <span className='img-dashboard'>
          <img src={isAkb ? akbIcon : defaultBoardImg} alt="default-board" />
        </span>
      );
    }
    
    if (!dashboard.organization) {
      return (
        <span className='img-dashboard'>
          <img src={isAkb ? akbIcon : personalBoardImg} alt={isAkb ? "default-board" : "personal-board"} />
        </span>
      );
    }
    
    return (
      <span className='img-dashboard'>
        <img
          src={dashboard.organization.logo}
          alt="org-logo"
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = defaultBoardImg;
          }}
        />
      </span>
    );
  };

  return (
    <div className='dashboard-info'>
      {renderDashboardImage()}
      <h1>{dashboard ? (dashboard.label || dashboard.name) : ''}</h1>
    </div>
  );
};

DashboardInfo.propTypes = {
  dashboard: PropTypes.object.isRequired
};

export default DashboardInfo;
